module.exports = __webpack_public_path__ + "img/ARRASTAR2.5721f2cc.svg";